import { DonutChart } from '@/components/charts/donut-chart';
import { Skeleton } from '@/components/ui/skeleton';

import type { PaymentMethodSale } from '../dashboard.api';

interface PaymentMethodsChartProps {
  data: PaymentMethodSale[] | undefined;
  loading: boolean;
}

/**
 * Distribución de las ventas por método de pago.
 *
 * El propio gráfico incluye la leyenda con el monto y el porcentaje de cada
 * método, así que la tarjeta no repite la lista debajo.
 */
export function PaymentMethodsChart({ data, loading }: PaymentMethodsChartProps) {
  if (loading) {
    return <Skeleton className="h-64 rounded-control" />;
  }

  const lista = (data ?? []).filter((item) => item && item.metodo);

  if (lista.length === 0) {
    return (
      <p className="py-8 text-center text-sm text-ink-500">
        Sin ventas registradas en este rango.
      </p>
    );
  }

  return (
    <div className="flex h-full flex-col justify-center">
      <DonutChart
        labels={lista.map((item) => item.metodo)}
        series={[{ label: 'Monto', data: lista.map((item) => Number(item.monto || 0)) }]}
        format="currency"
      />
    </div>
  );
}
